import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'state_location_type_position_rate_settings',
  inputShow: gql`
    query stateLocationTypePositionRateSettings(
      $input: StateLocationTypePositionRateSettingQueryInput
    ) {
      stateLocationTypePositionRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'State Location Type Position Rate Settings',
    order: 7,
  },
};
